module.exports = __webpack_public_path__ + "img/playlisterclub-logo-vector-light.e41c60bd.svg";